import React from "react"
import PropTypes from "prop-types"

const Card = ({ label, value, hint }) => (
  <div className="cfg-summary-card">
    <div className="cfg-summary-label">{label}</div>
    <div className="cfg-summary-value">{value}</div>
    <div className="cfg-summary-hint">{hint}</div>
  </div>
)

Card.propTypes = {
  label: PropTypes.string,
  value: PropTypes.any,
  hint: PropTypes.string,
}

const SummaryCards = ({ resumen }) => (
  <div className="cfg-summary cfg-anim">
    <Card
      label="Clientes configurados"
      value={resumen.total}
      hint="con ventana y comisión propias"
    />
    <Card
      label="Comisión promedio"
      value={resumen.promedio}
      hint={resumen.rango}
    />
    <Card
      label="Ventana más usada"
      value={resumen.ventanaTop}
      hint={resumen.ventanaTopCount}
    />
  </div>
)

SummaryCards.propTypes = {
  resumen: PropTypes.object.isRequired,
}

export default SummaryCards
